<template>
  <FileDocSvg v-if="type === 'document'" />
  <FileImageSvg v-else-if="type === 'image'" />
  <FileUnknownSvg v-else />
</template>

<script setup>
import { computed } from '@vue/runtime-core';

import { getFileTypeDescription } from '@/functions/utils';

import FileDocSvg from '@/images/file-doc.svg';
import FileImageSvg from '@/images/file-image.svg';
import FileUnknownSvg from '@/images/file-unknown.svg';

const props = defineProps({
  contentType: { type: String, default: '' },
});

const type = computed(() => getFileTypeDescription(props.contentType));
</script>
